import { useTheme, Box, Typography, Card } from "@mui/material"
import { deepmerge } from "@mui/utils"
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus"

import { useTranslation } from "providers/i18n"

export const BusStopCard = ({
  icon = <DirectionsBusIcon />,
  sx = {},
  title,
  origin,
  destination,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides = theme.components[`BusStopCard`]?.styleOverrides || {}
  const {
    root,
    headerWrapper,
    iconWrapper,
    headerTitle,
    contentWrapper,
    contentText,
  } = styleOverrides
  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <Box sx={headerWrapper}>
        {icon && <Box sx={iconWrapper}>{icon}</Box>}
        {title && (
          <Typography sx={headerTitle} variant="h6">
            {t(title)}
          </Typography>
        )}
      </Box>
      <Box sx={contentWrapper}>
        <Typography sx={contentText} variant="body2">{`${t("Origin")}: ${t(
          origin
        )}`}</Typography>
        <Typography sx={contentText} variant="body2">{`${t("Destination")}: ${t(
          destination
        )}`}</Typography>
      </Box>
    </Card>
  )
}
